<template>
  <div
    v-show="showFooterBar"
    class="footer-container fixed-bottom bg-white btn-tab-group"
  >
    <div class="footer-menu">
      <div class="footer-row d-flex justify-content-end">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterButtons',
  data() {
    return {
      showFooterBar: false,
    };
  },
  props: {
    range: {
      type: Number,
      default: 250,
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
    handleScroll() {
      let currentScrollPos = window.pageYOffset;
      this.showFooterBar = this.range <= currentScrollPos;
      this.prevScrollpos = currentScrollPos;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style scoped>
.footer-row button {
  margin-left: 8px;
  margin-bottom: 8px;
}
.footer-container {
  z-index: 50;
}
</style>
